import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { WeatherWallWindowRelations } from 'types';

export const getWeatherWall = async (
  wallId: number | undefined
): Promise<WeatherWallWindowRelations | undefined> => {
  if (wallId === undefined) return undefined;
  const { data } = await axios.get(`/api/weather/walls/${wallId}`);
  return data as WeatherWallWindowRelations | undefined;
};

type QueryFnType = typeof getWeatherWall;

type UseWeatherWallOptions = {
  wallId: number | undefined;
  config?: QueryConfig<QueryFnType>;
  xPos?: number;
  yPos?: number;
};

export const useWeatherWall = ({ wallId, config }: UseWeatherWallOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['weatherWalls', wallId],
    queryFn: () => getWeatherWall(wallId),
  });
};
